var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.158 4.614v-1.36a1.36 1.36 0 00-1.36-1.36H3.314a1.36 1.36 0 00-1.36 1.36v18.365",
    stroke: "#363B3D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.239 4.614H8.076v2.72h8.163v-2.72zM6.036 7.335h12.243",
    stroke: "#363B3D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.158 9.375a.68.68 0 100 1.361.68.68 0 000-1.36zm-3.402 0a.68.68 0 10.001 1.361.68.68 0 000-1.36zm6.802 0a.68.68 0 10.001 1.361.68.68 0 000-1.36zm-3.4 2.721a.68.68 0 100 1.36.68.68 0 000-1.36zm3.4 0a.68.68 0 10.001 1.361.68.68 0 000-1.361zm-6.802 0a.68.68 0 10.001 1.361.68.68 0 000-1.361zm3.402 2.72a.68.68 0 100 1.362.68.68 0 000-1.361zm3.4 0a.68.68 0 100 1.362.68.68 0 000-1.361zm-6.802 0a.68.68 0 100 1.362.68.68 0 000-1.361zm3.402 2.722a.68.68 0 100 1.36.68.68 0 000-1.36zm3.4 0a.68.68 0 100 1.36.68.68 0 000-1.36zm-6.802 0a.68.68 0 100 1.36.68.68 0 000-1.36zm3.402 2.72a.68.68 0 100 1.361.68.68 0 000-1.36zm3.4 0a.68.68 0 100 1.361.68.68 0 000-1.36zm-6.802 0a.68.68 0 100 1.361.68.68 0 000-1.36z",
    fill: "#363B3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.559 9.375a.68.68 0 100 1.361.68.68 0 000-1.36zm-3.401 0a.68.68 0 100 1.361.68.68 0 000-1.36zm3.4 2.721a.68.68 0 10.001 1.36.68.68 0 000-1.36zm-3.4 0a.68.68 0 100 1.36.68.68 0 000-1.36zm3.4 2.72a.68.68 0 100 1.362.68.68 0 000-1.361zm-3.4 0a.68.68 0 100 1.362.68.68 0 000-1.361zm3.4 2.722a.68.68 0 100 1.36.68.68 0 000-1.36zm-3.4 0a.68.68 0 100 1.36.68.68 0 000-1.36zm3.4 2.72a.68.68 0 100 1.361.68.68 0 000-1.36zm-3.4 0a.68.68 0 100 1.361.68.68 0 000-1.36z",
    fill: "#363B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.b14c8bd96fe23e4e327eb99ca8687d10.svg";
export { ForwardRef as ReactComponent };